var PES = PES || {};

PES.Navigation = function () {

    function showElements() {
        
        var logOut = $(".logoff");

        $(document).on('click tap', '.logoff', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            
            localStorage.removeItem(".OfficeTimeline.Cookies.SPE");
            var form = $(this).siblings("form");
            form.submit();
        });

        $(".ui-loader.ui-loader-default").hide();
    }


    var basketAnchorExists = function() {
        return $(".shopping-bag").length;
    };

    var loadBasketIems = function(basketItemsUrl) {
        if (basketAnchorExists()) {
            $.get(basketItemsUrl)
                .done(function(response) {
                    if (response && response.count > 0) {
                        $('#item-counter').html(response.count);
                        $('#item-counter').addClass('not-empty');
                    }
                });
        }
    };

    var userInfoAnchorExists = function() {
        return $(".user-logged-menu").length;
    };

    var loadUserInfo = function(userInfoUrl) {
        if (userInfoAnchorExists()) {
            $.get(userInfoUrl)
        }
    };

    var loadAccount = function (userInfoUrl, basketItemsUrl) {
        loadUserInfo(userInfoUrl);
        loadBasketIems(basketItemsUrl);
    };

    var init = function (userInfoUrl, basketItemsUrl) {
        $.ajaxSetup({ cache: false });
        loadAccount(userInfoUrl, basketItemsUrl);
        showElements();
    };

    return {
        init: init
    };
}();